import { setHeaderHeightVariable } from './modules/set-header-height-variable.js';
import { setViewportWidthVariable } from './modules/set-viewport-width-variable.js';
import { delayedScroll } from './modules/delayed-scroll.js';
import { disableTelOnPC } from './modules/disable-tel-on-pc.js';
import { pageFadeIn } from './modules/page-fade-in.js';
import { fullpageScroll } from './modules/fullpage-scroll.js';

/**
 * メインJavaScript - 各モジュールの初期化
 */
document.addEventListener('DOMContentLoaded', () => {
  setHeaderHeightVariable();
  setViewportWidthVariable();
  delayedScroll();
  disableTelOnPC();
  pageFadeIn();
  fullpageScroll();
});
